module.exports = __webpack_public_path__ + "app/principal/modals/modal-import-company-2TmIvOFJ.html";